/**
 * Set up any HTML element to act as a files browse button
 */
export class BrowseHandler {
	/**
	 * Setup the handlers
	 * @param {HTMLElement} element  The HTML element to make into a browse button
	 * @param {Object} options  Setup info
	 * @property {Boolean} multi_selection  True to allow selecting multiple files
	 * @property {Function<Files[]>} onpick  A callback to handle the browse event
	 */
	constructor(element, options) {
		// generate a unique dom id
		const uid = Math.random().toString(36).slice(2);
		// generate the input
		const input = this._createElement('input', {
			id: uid,
			type: 'file',
			multiple: !!options.multi_selection,
			style: {
				display: 'none',
			},
		});
		// listen for changes on input
		input.addEventListener('change', () => options.onpick(input.files));
		// generate the label
		const label = this._createElement('label', {
			htmlFor: uid,
			style: {
				position: 'absolute',
				top: '0',
				right: '0',
				bottom: '0',
				left: '0',
				zIndex: '2',
				cursor: 'pointer',
				backgroundColor: 'transparent',
				border: 'none',
			},
		});
		// setup the browse button
		element.style.position = 'relative';
		element.parentNode.insertBefore(input, element);
		// append the label
		element.appendChild(label);
		// allow later teardown
		this._browseInput = input;
		this._browseLabel = label;
	}

	/**
	 * Remove all listeners and hidden input
	 */
	teardown() {
		try {
			this._browseInput.parentNode.removeChild(this._browseInput);
		} catch (e) {
			// Component has unmounted already
		}
		try {
			this._browseLabel.parentNode.removeChild(this._browseLabel);
		} catch (e) {
			// Component has unmounted already
		}
		this._browseInput = null;
		this._browseLabel = null;
	}

	/**
	 * Helper function to create elements and assign attributes
	 * @param {String} tag  The tagName
	 * @param {Object} attributes  An object whose properties to recursively apply
	 * @returns {HTMLElement}
	 * @private
	 */
	_createElement(tag, attributes) {
		const el = document.createElement(tag);
		Object.keys(attributes).forEach(prop => {
			if (typeof attributes[prop] == 'object') {
				Object.keys(attributes[prop]).forEach(subprop => {
					el[prop][subprop] = attributes[prop][subprop];
				});
			} else {
				el[prop] = attributes[prop];
			}
		});
		return el;
	}
}
